/**
 * sessao.ts — helpers de permissão (espelham auth.User.has_permission).
 */

import type { Sessao } from '../api/auth'

export function temPermissao(sessao: Sessao, permissao: string): boolean {
  if (sessao.usuario.papel === 'super_admin') return true
  return sessao.usuario.permissoes.includes(permissao)
}

export function temAlgumaPermissao(sessao: Sessao, ...permissoes: string[]): boolean {
  return permissoes.some((p) => temPermissao(sessao, p))
}
